import { useToken } from '@privy-io/react-auth';
import { useCallback } from 'react';

import { type WalletOperation, WalletUnlockRequiredError } from './wallet-operation';
import { walletUnlockSession } from './wallet-unlock-session';

export function useWalletOperations(lock: () => Promise<void>) {
  const { getAccessToken } = useToken();

  const beginOperation = useCallback((): WalletOperation => {
    const operation = walletUnlockSession.beginOperation(Date.now());

    if (!operation.isCurrent()) {
      void lock();
    }

    return operation;
  }, [lock]);

  const recordActivity = useCallback(() => walletUnlockSession.touch(Date.now()), []);

  const getWalletAccessToken = useCallback(async (): Promise<string> => {
    const token = await beginOperation().run(() => getAccessToken().catch(() => null));

    if (token) {
      return token;
    }

    await lock();
    throw new WalletUnlockRequiredError();
  }, [beginOperation, getAccessToken, lock]);

  return { beginOperation, recordActivity, getWalletAccessToken };
}
